// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import moment from 'moment'
import Notify from 'vue2-notify'
import VueCryptojs from 'vue-cryptojs'
import 'bootstrap'
// import 'bootstrap/dist/css/bootstrap.min.css'
Vue.use(VueCryptojs)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  Vuex,
  store,
  template: '<App/>',
  components: {App}
})

Vue.use(Notify, {position: 'bottom-right'})

Vue.filter('date', function (value, format = 'DD MMM YYYY') {
  if (value) {
    return moment(String(value)).format(format)
  }
})

Vue.filter('commafy', function (num) {
  let str = num.toString().split('.')
  if (str[0].length >= 5) {
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,')
  }
  if (str[1] && str[1].length >= 5) {
    str[1] = str[1].replace(/(\d{3})/g, '$1 ')
  }
  return str.join('.')
})

Vue.filter('numberFormat', function (value) {
  if (!value) return '0'
  return Number(Math.round(value)).toLocaleString()
})

Vue.filter('format_address', function (value) {
  return value.replace(/,\s*$/, '')
})

Vue.filter('currency', function (value) {
  return parseFloat(value).toFixed(2)
})

export const globalStore = new Vue({
  data: {
    currencyChangeDate: moment('2019-10-15 00:00:00').format('YYYY-MM-DD hh:mm:ss')
  }
})



// WEBPACK FOOTER //
// ./src/main.js